import { Star } from 'lucide-react'
import { Button } from '@creanizer/ui'
import type { GeneratedName } from '@creanizer/types'
import type { CharacterInput, CharacterResult, SavedCharacter } from '../../../../types/character' // temp fix

interface NameGeneratorResultsProps {
  results: GeneratedName[]
  lastUsedSeed: number | null
  copiedIndex: number | null
  style: string
  handleCopy: (name: string, index: number) => Promise<void>
  handleSaveName: (name: GeneratedName) => boolean
  isNameSaved: (name: string) => boolean
}

export function NameGeneratorResults({
  results,
  lastUsedSeed,
  copiedIndex,
  style,
  handleCopy,
  handleSaveName,
  isNameSaved,
}: NameGeneratorResultsProps) {
  if (results.length === 0) {
    return null
  }

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">
          生成結果（{results.length}個）
        </h3>
        {lastUsedSeed && (
          <div className="text-sm text-gray-600">
            シード値: <span className="font-mono font-medium">{lastUsedSeed}</span>
          </div>
        )}
      </div>
      
      <div className="grid gap-2 max-h-96 overflow-y-auto">
        {results.map((item, index) => {
          const isSaved = isNameSaved(item.name)
          
          return (
            <div
              key={index}
              className="flex items-start justify-between p-3 border rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-medium text-lg">{item.name}</span>
                  {item.rarity && item.rarity >= 8 && (
                    <span className="text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded">
                      レア
                    </span>
                  )}
                  {isSaved && (
                    <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                  )}
                </div>
                {item.reading && (
                  <div className="text-sm text-gray-600 mt-1">
                    {/* 日本語名の場合は「読み:」、それ以外は「綴り:」と表示 */}
                    <span className="text-gray-500">
                      {style === 'modern_japanese' || style === 'japanese' ? '読み: ' : '綴り: '}
                    </span>
                    {item.reading}
                  </div>
                )}
                {item.meaning && (
                  <div className="text-sm text-gray-500 mt-1">
                    {item.meaning}
                  </div>
                )}
              </div>
              <div className="flex items-center gap-1">
                {!isSaved && (
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => {
                      const success = handleSaveName(item)
                      if (success) {
                        // 保存成功の視覚的フィードバック
                      }
                    }}
                    title="保存"
                  >
                    <Star className="h-4 w-4" />
                  </Button>
                )}
                <button
                  onClick={() => handleCopy(item.name, index)}
                  className="p-2 text-gray-500 hover:text-gray-700 transition-colors"
                  title="クリップボードにコピー"
                >
                  {copiedIndex === index ? '✓' : '📋'}
                </button>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}